<template lang="pug">
	li(v-bind:class="liClass")
		.navigation-entry
			span.page-number {{ index }}
			router-link(
				v-bind:class="linkClass"
				@click.native="onRouterPress"
				tabindex="-1"
				:exact="exact"
				:to="to"
			)
				| {{ label }}
		slot
</template>

<script>
export default {
	name : 'NavigationLink',
	props: {
		exact      : Boolean,
		to         : String,
		label      : String,
		index      : [String, Number],
		subindex   : [String, Number],
		selected   : Number,
		subSelected: Number,
		hasChildren: Boolean,
		activeArea : Boolean
	},
	computed: {
		liClass () {
			return {
				'link-children': this.hasChildren,
				'active-area'  : this.activeArea || this.subSelected
			}
		},
		linkClass () {
			if (this.subindex) {
				return {
					'link-keyboard-selected': this.subindex === this.selected
				}
			}
			return {
				'link-keyboard-selected': this.index === this.selected && !this.subSelected
			}
		}
	},
	methods: {
		onRouterPress (ev) {
			this.$emit('close')
			return true
		}
	}
}
</script>
